import {
  Component,
  ViewChild,
  TemplateRef,
  Output,
  Input,
  EventEmitter,
} from "@angular/core";
import {
  faAngleUp,
  faAngleDown,
  faSpinner,
} from "@fortawesome/pro-light-svg-icons";
import { MatSnackBarRef, MatSnackBar } from "@angular/material/snack-bar";
import { Subscription } from "rxjs";
import {
  faTimes,
  faCheck,
  faTimesCircle,
  faInfoCircle,
  faExclamationCircle as fasExclamationCircle,
  faTable as fasTable,
  faFileExcel as fasFileExcel,
  faChartLine as fasChartLine,
  faArrowToBottom as fasArrowToBottom,
} from "@fortawesome/pro-solid-svg-icons";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";
import {
  PeriodState,
  PeriodUserSettingObj,
  convertPeriodMetaToUserSettings,
  getSelectedBasisOptionId,
  isBasisFullYear,
} from "@va/core-library/period-filter";
import { Router } from "@angular/router";
import {
  CHART_TYPE_LIST,
  DEFAULT_CHART_TYPE,
  CHART_TYPE_DATA,
  TREND_REVISION_CHART_LEGEND_COLORS,
  COMPARISON_CHART_LEGEND_COLORS,
} from "../constants";
import {
  getMetaPayloadFromUrls,
  updateCustomTableSettings,
} from "src/app/comparative-analysis/comparative-analysis-utils";
import { ComparativeAnalysisService } from "./../comparative-analysis.service";
import {
  getSelectedPeriods,
  getPeriodTypeDataId,
  getOtherPeriods,
  convertRelativePeriodIdToLabel,
} from "src/app/utils/period-utils";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { LineItemModalComponent } from "src/app/shared/line-item-modal/line-item-modal.component";
import { CompsDataService } from "../../comps-page/comps-data.service";
import { WatchlistService } from "src/app/watchlist/watchlist.service";
import { AddWatchlistData } from "src/app/store/actions/global.actions";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { FACTSET_COPYRIGHT_MESSAGE } from "src/app/common-constants";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-comparative-charts",
  templateUrl: "./comparative-charts.component.html",
  styleUrls: ["./comparative-charts.component.scss"],
})
export class ComparativeChartsComponent {
  @Input() isActive = true;
  @Input() trendState;
  @Input() comparisonState;
  @Input() revisionState;
  @Input() shouldFetchData = false;
  @Output() updateChartState: EventEmitter<any> = new EventEmitter();
  @Output() onDataViewFilterChange = new EventEmitter();
  @Output() onDataFetchInitiate: EventEmitter<any> = new EventEmitter();
  @Output() isDownloadingInProgress: EventEmitter<any> = new EventEmitter();
  @Input() routeParams;
  @Input() routeQueryParams;
  @Input() pageType;
  @Input() compType;
  @Input() recentlyVisitedCompanies;
  @Input() watchlistData;
  @Input() industryMenuData;
  @Input() suggestedPeers;
  @Input() tickerModalDataReady;
  @Input() marketGeoData;
  @Input() compId;
  @Output() initiateWatchlistFetch: EventEmitter<any> = new EventEmitter();
  @Output() updateUnsavedDataStatus: EventEmitter<any> = new EventEmitter();

  //icons
  faAngleUp = faAngleUp;
  faAngleDown = faAngleDown;
  faTimes = faTimes;
  faCheck = faCheck;
  faTimesCircle = faTimesCircle;
  faInfoCircle = faInfoCircle;
  fasExclamationCircle = fasExclamationCircle;
  faSpinner = faSpinner;
  fasTable = fasTable;
  fasChartLine = fasChartLine;
  fasFileExcel = fasFileExcel;
  fasArrowToBottom = fasArrowToBottom;

  // filters data
  selectedChartType = DEFAULT_CHART_TYPE;
  tickers = [];
  customTickers = [];
  topTenTickers = {};
  trendRevisionSelectedLineItems;
  trendRevisionSelectedLineIds;
  comparisonSelectedLineItems;
  comparisonSelectedLineIds;
  currency = "";
  headerTitle = "";
  revisionValueOfRevisionChart = "";
  trendComparisonViewBy = "values";
  revisionViewBy = "revision";
  periodsWithAvailableData;
  trendPeriodData;
  comparisonPeriodData;
  revisionChartPeriodData;
  trendPeriodUserSetting;
  comparisonPeriodUserSetting;
  revisionChartPeriodUserSetting;
  trendPeriodList;
  comparisonPeriodList;
  revisionPeriodList;
  comparisonOtherPeriodList;
  revisionOtherPeriodList;
  trendPeriodType;
  comparisonPeriodType;
  revisionPeriodType;
  isIndexToHundreadSelected = false;
  tickerSelectionType;
  tickerIncludeAverageSelected;
  trendChartOptions;
  comparisonChartOptions;
  revisionChartOptions;
  viewportOptions;
  dataViewList = [
    { key: "Values", value: "values" },
    { key: "YoY%", value: "yoy" },
  ];
  magnitudeMessage;
  lineItemsData;
  suggestedLineItems;
  suggestedLineItemMenuName = "Suggested Line Items";
  chartOperation = "fetchData";
  cidMapper = {};
  storeDataKey = "watchlist";
  topTenTickerSize = 10;
  periodMinMax = { min: -10, max: 9 };
  factsetCopyRightMessage = FACTSET_COPYRIGHT_MESSAGE;
  industryId;
  trendPeriodLabel: Array<string>;
  comparisonPeriodLabel: Array<string>;
  revisionPeriodLabel: Array<string>;
  isChartPage = true;

  //
  apiEP: string = window.apiUrl;
  chartTypeDropdownOptions = CHART_TYPE_LIST;
  shouldFetchMeta;
  currencyOptionList: Array<any> = [
    { iso_currency: "USD", symbol: "$" },
    { iso_currency: "EUR", symbol: "$" },
    { iso_currency: "JPY", symbol: "$" },
  ];

  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  lineItemsModal: NzModalRef;
  modalTitle = "Edit Line Items";
  MAX_LINES_LINECHART = 10;
  MAX_LINES_BARCHART = 2;
  source = "VA Actuals/Consensus";
  isTrendMetaFetchedOnce = false;
  isComparisonMetaFetchedOnce = false;
  isRevisionMetaFetchedOnce = false;

  //subscribers
  chartMetaSubscriber: Subscription;
  lineItemsSubscriber: Subscription;
  currencyMessageSubscriber: Subscription;
  globalAppSettingSubscriber: Subscription;

  //page related variables
  tabType = "Charts";

  selectedLineItemId = [];
  overlayOn = false;

  //loaders
  isMetaInProgress;
  isUserSettingUpdateInProgress;
  isStdLineItemsUpdateInProgress = false;
  topTenTickersUpdateInProgress = false;

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;
  @ViewChild("warningTemplate") warningTemplate: TemplateRef<any>;

  constructor(
    private dataService: ComparativeAnalysisService,
    private appService: AppService,
    public router: Router,
    private snackBar: MatSnackBar,
    private modalService: NzModalService,
    private compsDataService: CompsDataService,
    private watchlistDataService: WatchlistService,
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([exclamationTriangle]);
  }

  ngOnInit() {
    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of common state to trigger data calls on all tabs
          if (
            !this.isMetaInProgress &&
            // this.gridData &&
            this.isActive
          ) {
            this.createChartDataOptions();
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const root =
        document.querySelector("#comprativeChartSection") || undefined;
      this.viewportOptions = {
        root,
        threshold: 0,
        rootMargin: "100% 0px 0px 0px",
      };
    }, 5);
  }

  ngOnChanges(changes) {
    // update state which is shared with other tabs
    if (
      changes.trendState &&
      changes.trendState.currentValue &&
      changes.trendState.currentValue !== changes.trendState.previusValue
    ) {
      this.tickers = this.trendState.tickers;
      this.customTickers = this.trendState.customTickers;
      this.tickerSelectionType = this.trendState.tickerSelectionType;
      this.headerTitle = this.trendState.headerTitle;
      this.trendPeriodLabel = this.trendState.periodLabel;
    }

    // charts comparison tabs shares period data with trend comps and comparison comps, so updating it here whenever there is change in comps
    if (
      changes.comparisonState &&
      changes.comparisonState.currentValue &&
      changes.comparisonState.currentValue !==
        changes.comparisonState.previusValue
    ) {
      this.comparisonPeriodData = this.comparisonState.periodData;
      this.comparisonPeriodList = this.comparisonState.periodList;
      this.comparisonPeriodUserSetting = this.comparisonState.periodUserSetting;
      this.comparisonPeriodType = this.comparisonState.periodType;
      this.comparisonPeriodLabel = this.comparisonState.periodLabel;
      this.comparisonOtherPeriodList =
        this.comparisonState.periodList &&
        this.comparisonState.periodList.filter(
          (item) => item === "NTM" || item === "LTM" || item === "STM",
        );
    }

    // first time visit
    if (
      (changes.routeParams &&
        changes.routeParams.currentValue &&
        changes.routeParams.currentValue !==
          changes.routeParams.previousValue) ||
      (changes.routeQueryParams &&
        changes.routeQueryParams.currentValue &&
        changes.routeQueryParams.currentValue !==
          changes.routeQueryParams.previousValue)
    ) {
      this.shouldFetchMeta = true;
      this.selectedChartType = DEFAULT_CHART_TYPE;
    }

    // on tab change
    if (
      changes.isActive &&
      changes.isActive.currentValue &&
      !changes.isActive.previousValue
    ) {
      if (this.shouldFetchMeta || changes.isActive.firstChange) {
        const isUserPageType = this.checkIfUserPageType();
        const chartMetaId = CHART_TYPE_DATA[this.selectedChartType]
          ? CHART_TYPE_DATA[this.selectedChartType].meta_id
          : undefined;
        const metaPayload = isUserPageType
          ? getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
              undefined,
              chartMetaId,
            )
          : getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
              this.trendState,
              chartMetaId,
            );
        this.fetchAndUpdateComparativeMeta(metaPayload, true);
        this.shouldFetchMeta = false;
      } else if (
        this.shouldFetchData &&
        this.tickers &&
        this.tickers.length &&
        !changes.isActive.firstChange
      ) {
        if (this.tickers && this.tickers.length) {
          this.createCidTickerMapping(this.tickers);
          let periodList = [];
          let uniquesliidList = [];
          let periodType = "absolute";
          // let viewBy = ["values"];
          if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
            uniquesliidList = this.trendRevisionSelectedLineIds;
            periodList = this.trendPeriodList;
            periodType = this.trendPeriodType;
            // viewBy = [this.trendComparisonViewBy];
          } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
            uniquesliidList = this.comparisonSelectedLineIds;
            periodList = this.comparisonPeriodList;
            periodType = this.comparisonPeriodType;
            // viewBy = [this.trendComparisonViewBy];
          } else {
            uniquesliidList = this.trendRevisionSelectedLineIds;
            periodList = this.revisionPeriodList;
            periodType = this.revisionPeriodType;
            // viewBy = [this.revisionViewBy];
          }
          const yearPeriodList = [];
          const otherPeriodList = [];
          for (const item of periodList) {
            if (item === "LTM" || item === "NTM" || item === "STM") {
              otherPeriodList.push(item);
            } else {
              yearPeriodList.push(item);
            }
          }
          const topTenPayload = {
            size: this.topTenTickerSize,
            cid: this.tickers.map(
              (ticker) => ticker.cid || ticker.company_id || ticker.companyid,
            ),
            uniquesliid: uniquesliidList,
            periods_list: yearPeriodList,
            include_top_tickers: true,
            currency: this.currency,
            period_type: periodType,
            other_period: otherPeriodList || [],
            chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
            // view_by: viewBy,
            include_average: this.tickerIncludeAverageSelected,
          };
          this.getTopTenTicker(topTenPayload).subscribe((response) => {
            if (response.status === "success") {
              this.topTenTickers = response.data.top_tickers;
              this.chartOperation = "fetchData";
              this.createChartDataOptions();
              // const dataToEmit = {
              //   topTenTickers: response.data.top_tickers,
              //   tickerSelectionType: "top_ten",
              // };
              // this.updateChartState.emit({
              //   chartStateToUpdate: ["trend", "comparison", "revision"],
              //   data: dataToEmit,
              // });
            }
            this.topTenTickersUpdateInProgress = false;
          });
        }
        this.onDataFetchInitiate.emit();
        this.chartOperation = "fetchData";
        const tickerIds = this.tickers.map((item) => {
          return item.ticker;
        });
        this.getPeriodsWithAvailableData(tickerIds);
        this.createChartDataOptions();
      }
    }
  }

  fetchAndUpdateComparativeMeta(metaPayload, fetchStdLines = false) {
    if (this.selectedChartType === CHART_TYPE_DATA.revision.id) {
      this.isRevisionMetaFetchedOnce = true;
    } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
      this.isComparisonMetaFetchedOnce = true;
    } else {
      this.isTrendMetaFetchedOnce = true;
    }

    this.shouldFetchMeta = false;
    this.isMetaInProgress = true;
    // reset filters on change of industry

    if (this.chartMetaSubscriber) {
      this.chartMetaSubscriber.unsubscribe();
    }
    this.chartMetaSubscriber = this.dataService
      .fetchComparativeAnalysisMeta(metaPayload)
      .subscribe(
        (response: { data: any; status: string; status_code?: number }) => {
          if (response.status === "success") {
            if (response.data) {
              // set data
              this.updateStateWithMeta(response.data);
              this.industryId = response.data.industry_id;
              this.chartOperation = "fetchData";
              this.createChartDataOptions();
              if (fetchStdLines) {
                this.fetchAndUpdateStdLineItems(
                  response.data.tickers.ticker_info,
                  false,
                  this.currency,
                  this.suggestedLineItems,
                );
              }
            }
          }
          this.isMetaInProgress = false;
        },
      );
  }

  fetchAndUpdateStdLineItems(
    tickers,
    showSuggestedLineItems,
    currency,
    suggestedLineItems,
  ) {
    if (!tickers || !tickers.length) {
      return;
    }
    const tickerIds = tickers.map((item) => item.ticker);

    this.isStdLineItemsUpdateInProgress = true;
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    this.lineItemsSubscriber = this.dataService
      .getStdLineItems(tickerIds, showSuggestedLineItems, currency, true)
      .subscribe((response) => {
        if (response.status === "success") {
          const stdData = response.data;
          const formattedStdLineItems = [];
          if (!showSuggestedLineItems && suggestedLineItems) {
            const suggestLineItems = {
              tab_full_name: this.suggestedLineItemMenuName,
              tab_short_name: "SL",
              tab_sli_data: suggestedLineItems,
            };
            formattedStdLineItems.push(suggestLineItems);
          }
          for (const item of stdData) {
            const formattedTabSliData = [];
            // format the tab_sli_data to match data shape of lineItems required for LineitemSearchComponent component
            for (const lineItem of item.tab_sli_data) {
              formattedTabSliData.push({
                ...lineItem,
                label: lineItem.name,
                sli_id_count: lineItem.sli_id_count,
                id: lineItem.uniquesliid,
                disabled: false,
                isLeaf: true,
                level: 2,
                header: false,
                isCollapsed: true,
              });
            }
            const currentItem = {
              tab_full_name: item.tab_full_name,
              tab_short_name: item.tab_short_name,
              tab_sli_data: formattedTabSliData,
            };
            formattedStdLineItems.push(currentItem);
          }
          this.lineItemsData = formattedStdLineItems;
        }
        this.isStdLineItemsUpdateInProgress = false;
      });
  }

  handleInitiateWatchlistFetch() {
    this.initiateWatchlistFetch.emit();
  }

  checkIfUserPageType() {
    return this.pageType === "user";
  }

  getLiMaxLimit() {
    return this.selectedChartType === CHART_TYPE_DATA.comparison.id
      ? this.MAX_LINES_BARCHART
      : this.MAX_LINES_LINECHART;
  }

  /**
   * Executes on the selection of lineitem
   * It checks if lineitem exists or not and shows toast message according to it.
   * It formats the line item, and removes unnecessary items
   * It updates the line item
   * @param {object} item - selected lineitem
   */
  handleLineItemSelection(item) {
    const maxLiLimit = this.getLiMaxLimit();
    let previouslySelectedLineitems = [];
    let settingsPropertyToUpdate = "";
    let previouslySelectedLineitemId = [];
    if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
      previouslySelectedLineitems = this.comparisonSelectedLineItems;
      settingsPropertyToUpdate = "charts_bar_lids";
      previouslySelectedLineitemId = this.comparisonSelectedLineIds;
    } else {
      previouslySelectedLineitems = this.trendRevisionSelectedLineItems;
      settingsPropertyToUpdate = "charts_rev_trend_lids";
      previouslySelectedLineitemId = this.trendRevisionSelectedLineIds;
    }

    if (item && previouslySelectedLineitems.length < maxLiLimit) {
      const formatLineItem = { ...item, parent: undefined }; // remove the parent property from selected lineitem
      const isUserPageType = this.checkIfUserPageType();
      if (isUserPageType) {
        this.isUserSettingUpdateInProgress = true;
        const lineItemToUpdate = {
          LineItem: {
            [settingsPropertyToUpdate]: previouslySelectedLineitemId.concat(
              formatLineItem.uniquesliid,
            ),
          },
        };
        const settingsPayload = updateCustomTableSettings(
          this.compId,
          CHART_TYPE_DATA[this.selectedChartType].meta_id,
          lineItemToUpdate,
        );
        this.dataService
          .updateCustomComps(settingsPayload)
          .subscribe((response) => {
            if (response.status === "success") {
              this.updateLineItem(formatLineItem);
            }
            this.isUserSettingUpdateInProgress = false;
          });
      } else {
        this.updateLineItem(formatLineItem);
        this.updateUnsavedDataStatus.emit();
      }
    } else {
      this.snackbarInfo.message = `Chart for ${item.label} has not been added. ${previouslySelectedLineitems.length} of ${maxLiLimit} line items selected.`;
      this.snackbarInfo.type = "warning";
      this.showSnackBarToastMessage(this.snackbarInfo, null);
    }
  }

  updateLineItem(item) {
    const maxLiLimit = this.getLiMaxLimit();
    let currentLiCount = 0;
    const id = item.uniquesliid || item.sli_id;
    if (this.tickerSelectionType === "top_ten") {
      let periodList = [];
      let uniquesliidList = [];
      let periodType = "absolute";
      // let viewBy = ["values"];
      if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
        uniquesliidList = this.trendRevisionSelectedLineIds.concat(id);
        periodList = this.trendPeriodList;
        periodType = this.trendPeriodType;
        // viewBy = [this.trendComparisonViewBy];
      } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
        uniquesliidList = this.comparisonSelectedLineIds.concat(id);
        periodList = this.comparisonPeriodList;
        periodType = this.comparisonPeriodType;
        // viewBy = [this.trendComparisonViewBy];
      } else {
        uniquesliidList = this.trendRevisionSelectedLineIds.concat(id);
        periodList = this.revisionPeriodList;
        periodType = this.revisionPeriodType;
        // viewBy = [this.revisionViewBy];
      }
      const yearPeriodList = [];
      const otherPeriodList = [];
      for (const item of periodList) {
        if (item === "LTM" || item === "NTM" || item === "STM") {
          otherPeriodList.push(item);
        } else {
          yearPeriodList.push(item);
        }
      }
      const topTenPayload = {
        size: this.topTenTickerSize,
        cid: this.tickers.map(
          (ticker) => ticker.cid || ticker.company_id || ticker.companyid,
        ),
        uniquesliid: uniquesliidList,
        periods_list: yearPeriodList,
        include_top_tickers: true,
        currency: this.currency,
        period_type: periodType,
        other_period: otherPeriodList || [],
        chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
        // view_by: viewBy,
        include_average: this.tickerIncludeAverageSelected,
      };
      this.getTopTenTicker(topTenPayload).subscribe((response) => {
        if (response.status === "success") {
          let chartStateToUpdate = [];
          if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
            this.comparisonSelectedLineIds =
              this.comparisonSelectedLineIds.concat(id);
            this.comparisonSelectedLineItems =
              this.comparisonSelectedLineItems.concat(item);
            chartStateToUpdate = ["comparison"];
          } else {
            this.trendRevisionSelectedLineIds =
              this.trendRevisionSelectedLineIds.concat(id);
            this.trendRevisionSelectedLineItems =
              this.trendRevisionSelectedLineItems.concat(item);
            chartStateToUpdate = ["trend", "revision"];
          }
          this.topTenTickers = response.data.top_tickers;
          this.chartOperation = "fetchData";
          this.createChartDataOptions();
          const dataToEmit = {
            lineItem:
              this.selectedChartType === CHART_TYPE_DATA.comparison.id
                ? this.comparisonSelectedLineItems
                : this.trendRevisionSelectedLineItems,
            selectedLineItemId:
              this.selectedChartType === CHART_TYPE_DATA.comparison.id
                ? this.comparisonSelectedLineIds
                : this.trendRevisionSelectedLineIds,
            topTenTickers: response.data.top_tickers,
            tickerSelectionType: "top_ten",
          };
          this.updateFormattedLineItem(dataToEmit, chartStateToUpdate);
          currentLiCount =
            this.selectedChartType === CHART_TYPE_DATA.comparison.id
              ? this.comparisonSelectedLineIds.length
              : this.trendRevisionSelectedLineIds.length;
          this.snackbarInfo.message = `Chart for ${item.label} has been added. ${currentLiCount} of ${maxLiLimit} line items selected.`;
          this.snackbarInfo.type = "success";
          this.showSnackBarToastMessage(this.snackbarInfo);
        }
        this.topTenTickersUpdateInProgress = false;
      });
    } else {
      let chartStateToUpdate = [];
      if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
        this.comparisonSelectedLineIds =
          this.comparisonSelectedLineIds.concat(id);
        this.comparisonSelectedLineItems =
          this.comparisonSelectedLineItems.concat(item);
        chartStateToUpdate = ["comparison"];
      } else {
        this.trendRevisionSelectedLineIds =
          this.trendRevisionSelectedLineIds.concat(id);
        this.trendRevisionSelectedLineItems =
          this.trendRevisionSelectedLineItems.concat(item);
        chartStateToUpdate = ["trend", "revision"];
      }
      // let chartStateToUpdate = this.selectedChartType === CHART_TYPE_DATA.comparison.id ? ["comparison"] : ["trend", "revision"];
      this.chartOperation = "fetchData";
      this.createChartDataOptions();
      const dataToEmit = {
        lineItem:
          this.selectedChartType === CHART_TYPE_DATA.comparison.id
            ? this.comparisonSelectedLineItems
            : this.trendRevisionSelectedLineItems,
        selectedLineItemId:
          this.selectedChartType === CHART_TYPE_DATA.comparison.id
            ? this.comparisonSelectedLineIds
            : this.trendRevisionSelectedLineIds,
      };
      this.updateFormattedLineItem(dataToEmit, chartStateToUpdate);
      currentLiCount =
        this.selectedChartType === CHART_TYPE_DATA.comparison.id
          ? this.comparisonSelectedLineIds.length
          : this.trendRevisionSelectedLineIds.length;
      this.snackbarInfo.message = `Chart for ${item.label} has been added. ${currentLiCount} of ${maxLiLimit} line items selected.`;
      this.snackbarInfo.type = "success";
      this.showSnackBarToastMessage(this.snackbarInfo);
    }
  }

  updateMultipleLineItem(item) {
    const lineitemId = [];
    const lineItems = [];
    for (const li of item) {
      lineItems.push(li);
      lineitemId.push(li.uniquesliid || li.sli_id);
    }
    if (this.tickerSelectionType === "top_ten") {
      let periodList = [];
      let uniquesliidList = [];
      let periodType = "absolute";
      // let viewBy = ["values"];
      if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
        uniquesliidList = lineitemId;
        periodList = this.trendPeriodList;
        periodType = this.trendPeriodType;
        // viewBy = [this.trendComparisonViewBy];
      } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
        uniquesliidList = lineitemId;
        periodList = this.comparisonPeriodList;
        periodType = this.comparisonPeriodType;
        // viewBy = [this.trendComparisonViewBy];
      } else {
        uniquesliidList = lineitemId;
        periodList = this.revisionPeriodList;
        periodType = this.revisionPeriodType;
        // viewBy = [this.revisionViewBy];
      }
      const yearPeriodList = [];
      const otherPeriodList = [];
      for (const item of periodList) {
        if (item === "LTM" || item === "NTM" || item === "STM") {
          otherPeriodList.push(item);
        } else {
          yearPeriodList.push(item);
        }
      }
      const topTenPayload = {
        size: this.topTenTickerSize,
        cid: this.tickers.map(
          (ticker) => ticker.cid || ticker.company_id || ticker.companyid,
        ),
        uniquesliid: uniquesliidList,
        periods_list: yearPeriodList,
        include_top_tickers: true,
        currency: this.currency,
        period_type: periodType,
        other_period: otherPeriodList || [],
        chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
        // view_by: viewBy,
        include_average: this.tickerIncludeAverageSelected,
      };
      this.getTopTenTicker(topTenPayload).subscribe((response) => {
        if (response.status === "success") {
          let chartStateToUpdate = [];
          if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
            this.comparisonSelectedLineIds = lineitemId;
            this.comparisonSelectedLineItems = lineItems;
            chartStateToUpdate = ["comparison"];
          } else {
            this.trendRevisionSelectedLineIds = lineitemId;
            this.trendRevisionSelectedLineItems = lineItems;
            chartStateToUpdate = ["trend", "revision"];
          }
          this.topTenTickers = response.data.top_tickers;
          this.chartOperation = "fetchData";
          this.createChartDataOptions();
          const dataToEmit = {
            lineItem: lineItems,
            selectedLineItemId: lineitemId,
            topTenTickers: response.data.top_tickers,
            tickerSelectionType: "top_ten",
          };
          this.updateFormattedLineItem(dataToEmit, chartStateToUpdate);
        }
        this.topTenTickersUpdateInProgress = false;
      });
    } else {
      let chartStateToUpdate = [];
      if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
        this.comparisonSelectedLineIds = lineitemId;
        this.comparisonSelectedLineItems = lineItems;
        chartStateToUpdate = ["comparison"];
      } else {
        this.trendRevisionSelectedLineIds = lineitemId;
        this.trendRevisionSelectedLineItems = lineItems;
        chartStateToUpdate = ["trend", "revision"];
      }
      this.chartOperation = "fetchData";
      // let chartStateToUpdate = this.selectedChartType === CHART_TYPE_DATA.comparison.id ? ["comparison"] : ["trend", "revision"];
      this.createChartDataOptions();
      const dataToEmit = {
        lineItem: lineItems,
        selectedLineItemId: lineitemId,
      };
      this.updateFormattedLineItem(dataToEmit, chartStateToUpdate);
    }
  }

  handleMultipleLineItemSelection(item) {
    if (item) {
      const lineItems = [...item]; // remove the parent property from selected lineitem
      const isUserPageType = this.checkIfUserPageType();

      if (isUserPageType) {
        let settingsPropertyToUpdate = "";
        if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
          settingsPropertyToUpdate = "charts_bar_lids";
        } else {
          settingsPropertyToUpdate = "charts_rev_trend_lids";
        }
        this.isUserSettingUpdateInProgress = true;
        const lineItemToUpdate = {
          LineItem: {
            [settingsPropertyToUpdate]: lineItems.map(
              (item) => item.uniquesliid,
            ),
          },
        };
        const settingsPayload = updateCustomTableSettings(
          this.compId,
          CHART_TYPE_DATA[this.selectedChartType].meta_id, //charts
          lineItemToUpdate,
        );
        this.dataService
          .updateCustomComps(settingsPayload)
          .subscribe((response) => {
            if (response.status === "success") {
              this.updateMultipleLineItem(lineItems);
            }
            this.isUserSettingUpdateInProgress = false;
          });
      } else {
        this.updateMultipleLineItem(lineItems);
        this.updateUnsavedDataStatus.emit();
      }
    }
  }

  updateEditLineItems(data) {
    this.handleMultipleLineItemSelection(data);
    this.destroyModal();
  }

  handleEditLineItems() {
    this.lineItemsModal = this.modalService.create({
      nzTitle: this.modalTitle,
      nzOkLoading: true,
      nzContent: LineItemModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addColTableData: this.getSelectedLineItems(),
        stdLineItems: this.lineItemsData,
        max: this.getLiMaxLimit(),
        maxHeight: "290px",
        tickers: this.tickers,
        createSource:
          this.source === "VA Actuals/Consensus"
            ? "vaactuals.consensus"
            : this.source,
        marketItemsData: [],
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.lineItemsModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          nzClassName: (data) => {
            return data.modalData.length > data.max ? "disable" : "";
          },
          onClick: (data): void => {
            this.updateEditLineItems(data.modalData);
            // if(this.updated)
            // this.lineItemsModal.destroy();
          },
          disabled: (data) => {
            // let disable = data.modalData.length > 50 ? true : false;
            // if(disable){
            //   document.getElementsByClassName("update-btn")? document.getElementsByClassName("update-btn")[0].setAttribute("nz-tooltip", ""):'';
            //   document.getElementsByClassName("update-btn")? document.getElementsByClassName("update-btn")[0].setAttribute("nzTooltipTitle", "exceeded"):'';
            // }
            return (
              data.modalData.length > data.max || data.modalData.length === 0
            );
          },
        },
      ],
      nzOnCancel: () => {
        // reset market items to last state
      },
    });
    this.dismissSnackBar();
  }

  destroyModal(): void {
    this.lineItemsModal.destroy();
  }

  /**
   * This function is fired when the save currency event is fired from the currency filter component.
   * It updates the currency in the state and calls the saveusersettings api to save it.
   * @param item selected currency
   */
  updateCurrency(item: string) {
    if (!item) {
      return;
    }
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const currencyToUpdate = {
        Currency: {
          currency_iso: item,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        CHART_TYPE_DATA[this.selectedChartType].meta_id,
        currencyToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.currency = item;
            this.currencyMessageSubscriber = this.compsDataService
              .getCurrencyMessage(item)
              .subscribe((res) => {
                if (res["status"] === "success") {
                  this.magnitudeMessage = res["magnitude_message"];
                } else {
                  this.snackbarInfo.message = "Could not update currency";
                  this.snackbarInfo.type = "failure";
                  this.showSnackBarToastMessage(this.snackbarInfo);
                }
                this.chartOperation = "fetchData";
                this.createChartDataOptions();
                const dataToEmit = {
                  lineItem:
                    this.selectedChartType === CHART_TYPE_DATA.comparison.id
                      ? this.comparisonSelectedLineItems
                      : this.trendRevisionSelectedLineItems,
                  selectedLineItemId:
                    this.selectedChartType === CHART_TYPE_DATA.comparison.id
                      ? this.comparisonSelectedLineIds
                      : this.trendRevisionSelectedLineIds,
                };
                this.updateFormattedLineItem(dataToEmit, [
                  "trend",
                  "comparison",
                  "revision",
                ]);
              });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      const chartStateToUpdate = ["trend", "comparison", "revision"];
      this.currency = item;
      this.currencyMessageSubscriber = this.compsDataService
        .getCurrencyMessage(item)
        .subscribe((res) => {
          if (res["status"] === "success") {
            this.magnitudeMessage = res["magnitude_message"];
          } else {
            this.snackbarInfo.message = "Could not update currency";
            this.snackbarInfo.type = "failure";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }
          this.chartOperation = "fetchData";
          this.createChartDataOptions();
          const dataToEmit = {
            lineItem:
              this.selectedChartType === CHART_TYPE_DATA.comparison.id
                ? this.comparisonSelectedLineItems
                : this.trendRevisionSelectedLineItems,
            selectedLineItemId:
              this.selectedChartType === CHART_TYPE_DATA.comparison.id
                ? this.comparisonSelectedLineIds
                : this.trendRevisionSelectedLineIds,
          };
          this.updateFormattedLineItem(dataToEmit, chartStateToUpdate);
        });
      this.updateChartState.emit({
        chartStateToUpdate: chartStateToUpdate,
        data: { currency: item },
      });
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * Executes on click of Period filter popup's Apply button.
   * It posts the selected period setting to user setting api
   * It updates periodData and periodSettings
   * @param {{updatedPeriodData: PeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodApply(periodData: {
    updatedPeriodData: PeriodState;
    periodUserSettingData: PeriodUserSettingObj;
  }) {
    const { updatedPeriodData, periodUserSettingData } = periodData;
    const updatedPeriodList = getSelectedPeriods(
      updatedPeriodData,
      false,
      false,
      true,
    );
    const periodType = getPeriodTypeDataId(updatedPeriodData);
    const periodList = [];
    const otherPeriodList = [];
    for (const item of updatedPeriodList) {
      if (item === "LTM" || item === "NTM" || item === "STM") {
        otherPeriodList.push(item);
      } else {
        periodList.push(item);
      }
    }
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const periodToUpdate = {
        Period: periodData.periodUserSettingData,
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        CHART_TYPE_DATA[this.selectedChartType].meta_id,
        periodToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            if (this.tickerSelectionType === "top_ten") {
              let uniquesliidList = [];
              // let viewBy = ["values"];
              if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
                uniquesliidList = this.trendRevisionSelectedLineIds;
                // viewBy = [this.trendComparisonViewBy];
              } else if (
                this.selectedChartType === CHART_TYPE_DATA.comparison.id
              ) {
                uniquesliidList = this.comparisonSelectedLineIds;
                // viewBy = [this.trendComparisonViewBy];
              } else {
                uniquesliidList = this.trendRevisionSelectedLineIds;
                // viewBy = [this.revisionViewBy];
              }
              const topTenPayload = {
                size: this.topTenTickerSize,
                cid: this.tickers.map(
                  (ticker) =>
                    ticker.cid || ticker.company_id || ticker.companyid,
                ),
                uniquesliid: uniquesliidList,
                periods_list: periodList,
                include_top_tickers: true,
                currency: this.currency,
                period_type: periodType,
                other_period: otherPeriodList || [],
                chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
                // view_by: viewBy,
                include_average: this.tickerIncludeAverageSelected,
              };
              this.getTopTenTicker(topTenPayload).subscribe((response) => {
                if (response.status === "success") {
                  if (this.selectedChartType === CHART_TYPE_DATA.revision.id) {
                    this.revisionChartPeriodData = updatedPeriodData;
                    this.revisionChartPeriodUserSetting = periodUserSettingData;
                    this.revisionPeriodList = updatedPeriodList;
                    const periodType = getPeriodTypeDataId(updatedPeriodData);
                    this.revisionPeriodType = periodType;
                    this.revisionOtherPeriodList = otherPeriodList;
                    this.revisionPeriodLabel = this.createPeriodLabel(
                      this.revisionChartPeriodUserSetting.type,
                      this.revisionPeriodList,
                      this.revisionChartPeriodData,
                    );
                  } else if (
                    this.selectedChartType === CHART_TYPE_DATA.comparison.id
                  ) {
                    this.comparisonPeriodData = updatedPeriodData;
                    this.comparisonPeriodUserSetting = periodUserSettingData;
                    this.comparisonPeriodList = updatedPeriodList;
                    const periodType = getPeriodTypeDataId(updatedPeriodData);
                    this.comparisonPeriodType = periodType;
                    this.comparisonOtherPeriodList = otherPeriodList;
                    this.comparisonPeriodLabel = this.createPeriodLabel(
                      this.comparisonPeriodUserSetting.type,
                      this.comparisonPeriodList,
                      this.comparisonPeriodData,
                    );
                  } else {
                    this.trendPeriodData = updatedPeriodData;
                    this.trendPeriodUserSetting = periodUserSettingData;
                    this.trendPeriodList = updatedPeriodList;
                    const periodType = getPeriodTypeDataId(updatedPeriodData);
                    this.trendPeriodType = periodType;
                    this.trendPeriodLabel = this.createPeriodLabel(
                      this.trendPeriodUserSetting.type,
                      this.trendPeriodList,
                      this.trendPeriodData,
                    );
                  }
                  this.topTenTickers = response.data.top_tickers;
                  this.chartOperation = "fetchData";
                  this.createChartDataOptions();
                  const dataToEmit = {
                    periodUserSetting: periodUserSettingData,
                    topTenTickers: this.topTenTickers,
                    periodData: updatedPeriodData,
                    periodType: periodType,
                    periodList: updatedPeriodList,
                    periodLabel: this.getPeriodLabel(),
                  };
                  this.updateChartState.emit({
                    chartStateToUpdate: [this.selectedChartType],
                    data: dataToEmit,
                  });
                }
                this.topTenTickersUpdateInProgress = false;
              });
            } else {
              if (this.selectedChartType === CHART_TYPE_DATA.revision.id) {
                this.revisionChartPeriodData = updatedPeriodData;
                this.revisionChartPeriodUserSetting = periodUserSettingData;
                this.revisionPeriodList = updatedPeriodList;
                const periodType = getPeriodTypeDataId(updatedPeriodData);
                this.revisionPeriodType = periodType;
                this.revisionOtherPeriodList = otherPeriodList;
                this.revisionPeriodLabel = this.createPeriodLabel(
                  this.revisionChartPeriodUserSetting.type,
                  this.revisionPeriodList,
                  this.revisionChartPeriodData,
                );
              } else if (
                this.selectedChartType === CHART_TYPE_DATA.comparison.id
              ) {
                this.comparisonPeriodData = updatedPeriodData;
                this.comparisonPeriodUserSetting = periodUserSettingData;
                this.comparisonPeriodList = updatedPeriodList;
                const periodType = getPeriodTypeDataId(updatedPeriodData);
                this.comparisonPeriodType = periodType;
                this.comparisonOtherPeriodList = otherPeriodList;
                this.comparisonPeriodLabel = this.createPeriodLabel(
                  this.comparisonPeriodUserSetting.type,
                  this.comparisonPeriodList,
                  this.comparisonPeriodData,
                );
              } else {
                this.trendPeriodData = updatedPeriodData;
                this.trendPeriodUserSetting = periodUserSettingData;
                this.trendPeriodList = updatedPeriodList;
                const periodType = getPeriodTypeDataId(updatedPeriodData);
                this.trendPeriodType = periodType;
                this.trendPeriodLabel = this.createPeriodLabel(
                  this.trendPeriodUserSetting.type,
                  this.trendPeriodList,
                  this.trendPeriodData,
                );
              }
              this.chartOperation = "fetchData";
              this.createChartDataOptions();
              this.updateChartState.emit({
                chartStateToUpdate: [this.selectedChartType],
                data: {
                  periodUserSetting: periodUserSettingData,
                  topTenTickers: this.topTenTickers,
                  periodData: updatedPeriodData,
                  periodType: periodType,
                  periodList: updatedPeriodList,
                  periodLabel: this.getPeriodLabel(),
                },
              });
            }
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      if (this.tickerSelectionType === "top_ten") {
        let uniquesliidList = [];
        // let viewBy = ["values"];
        if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
          uniquesliidList = this.trendRevisionSelectedLineIds;
          // viewBy = [this.trendComparisonViewBy];
        } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
          uniquesliidList = this.comparisonSelectedLineIds;
          // viewBy = [this.trendComparisonViewBy];
        } else {
          uniquesliidList = this.trendRevisionSelectedLineIds;
          // viewBy = [this.revisionViewBy];
        }
        const topTenPayload = {
          size: this.topTenTickerSize,
          cid: this.tickers.map(
            (ticker) => ticker.cid || ticker.company_id || ticker.companyid,
          ),
          uniquesliid: uniquesliidList,
          periods_list: periodList,
          include_top_tickers: true,
          currency: this.currency,
          period_type: periodType,
          other_period: otherPeriodList || [],
          chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
          // view_by: viewBy,
          include_average: this.tickerIncludeAverageSelected,
        };
        this.getTopTenTicker(topTenPayload).subscribe((response) => {
          if (response.status === "success") {
            if (this.selectedChartType === CHART_TYPE_DATA.revision.id) {
              this.revisionChartPeriodData = updatedPeriodData;
              this.revisionChartPeriodUserSetting = periodUserSettingData;
              this.revisionPeriodList = updatedPeriodList;
              const periodType = getPeriodTypeDataId(updatedPeriodData);
              this.revisionPeriodType = periodType;
              this.revisionOtherPeriodList = otherPeriodList;
              this.revisionPeriodLabel = this.createPeriodLabel(
                this.revisionChartPeriodUserSetting.type,
                this.revisionPeriodList,
                this.revisionChartPeriodData,
              );
            } else if (
              this.selectedChartType === CHART_TYPE_DATA.comparison.id
            ) {
              this.comparisonPeriodData = updatedPeriodData;
              this.comparisonPeriodUserSetting = periodUserSettingData;
              this.comparisonPeriodList = updatedPeriodList;
              const periodType = getPeriodTypeDataId(updatedPeriodData);
              this.comparisonPeriodType = periodType;
              this.comparisonOtherPeriodList = otherPeriodList;
              this.comparisonPeriodLabel = this.createPeriodLabel(
                this.comparisonPeriodUserSetting.type,
                this.comparisonPeriodList,
                this.comparisonPeriodData,
              );
            } else {
              this.trendPeriodData = updatedPeriodData;
              this.trendPeriodUserSetting = periodUserSettingData;
              this.trendPeriodList = updatedPeriodList;
              const periodType = getPeriodTypeDataId(updatedPeriodData);
              this.trendPeriodType = periodType;
              this.trendPeriodLabel = this.createPeriodLabel(
                this.trendPeriodUserSetting.type,
                this.trendPeriodList,
                this.trendPeriodData,
              );
            }
            this.topTenTickers = response.data.top_tickers;
            this.chartOperation = "fetchData";
            this.createChartDataOptions();
            const dataToEmit = {
              periodUserSetting: periodUserSettingData,
              topTenTickers: this.topTenTickers,
              periodData: updatedPeriodData,
              periodType: periodType,
              periodList: updatedPeriodList,
              periodLabel: this.getPeriodLabel(),
            };
            this.updateChartState.emit({
              chartStateToUpdate: [this.selectedChartType],
              data: dataToEmit,
            });
          }
          this.topTenTickersUpdateInProgress = false;
        });
      } else {
        if (this.selectedChartType === CHART_TYPE_DATA.revision.id) {
          this.revisionChartPeriodData = updatedPeriodData;
          this.revisionChartPeriodUserSetting = periodUserSettingData;
          this.revisionPeriodList = updatedPeriodList;
          const periodType = getPeriodTypeDataId(updatedPeriodData);
          this.revisionPeriodType = periodType;
          this.revisionOtherPeriodList = otherPeriodList;
          this.revisionPeriodLabel = this.createPeriodLabel(
            this.revisionChartPeriodUserSetting.type,
            this.revisionPeriodList,
            this.revisionChartPeriodData,
          );
        } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
          this.comparisonPeriodData = updatedPeriodData;
          this.comparisonPeriodUserSetting = periodUserSettingData;
          this.comparisonPeriodList = updatedPeriodList;
          const periodType = getPeriodTypeDataId(updatedPeriodData);
          this.comparisonPeriodType = periodType;
          this.comparisonOtherPeriodList = otherPeriodList;
          this.comparisonPeriodLabel = this.createPeriodLabel(
            this.comparisonPeriodUserSetting.type,
            this.comparisonPeriodList,
            this.comparisonPeriodData,
          );
        } else {
          this.trendPeriodData = updatedPeriodData;
          this.trendPeriodUserSetting = periodUserSettingData;
          this.trendPeriodList = updatedPeriodList;
          const periodType = getPeriodTypeDataId(updatedPeriodData);
          this.trendPeriodType = periodType;
          this.trendPeriodLabel = this.createPeriodLabel(
            this.trendPeriodUserSetting.type,
            this.trendPeriodList,
            this.trendPeriodData,
          );
        }
        this.chartOperation = "fetchData";
        this.createChartDataOptions();
        this.updateChartState.emit({
          chartStateToUpdate: [this.selectedChartType],
          data: {
            periodUserSetting: periodUserSettingData,
            periodData: updatedPeriodData,
            periodType: periodType,
            periodList: updatedPeriodList,
            periodLabel: this.getPeriodLabel(),
          },
        });
      }
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info, duration = 5000) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type, duration);
  }

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
      this.overlayOn = false;
    }
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type, duration = 5000) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
      warning: this.warningTemplate,
    };
    if (typeMap[type]) {
      if (type === "warning") {
        this.overlayOn = true;
      }
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: duration,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  updateTickers(data) {
    const { modalData, watchlistName, watchlistError } = data;
    const updatedTickerCidList = modalData.map(
      (item) => item.company_id || item.cid || item.companyid,
    );

    const tickerSelectionType = "top_ten";
    const customTickers = [];

    // FOR SAVING WATCHLIST
    if (data.saveWatchlist) {
      this.saveWatchlist(watchlistError, modalData, watchlistName);
    }

    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: updatedTickerCidList,
          chart_ticker_selected_type: tickerSelectionType,
          chart_custom_cid: customTickers,
          chart_include_average: this.tickerIncludeAverageSelected || false,
        },
      };

      const settingsPayload = updateCustomTableSettings(
        this.compId,
        CHART_TYPE_DATA[this.selectedChartType].meta_id,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.tickers = modalData;
            this.createCidTickerMapping(modalData);
            let periodList = [];
            let uniquesliidList = [];
            let periodType = "absolute";
            // let viewBy = ["values"];
            if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
              uniquesliidList = this.trendRevisionSelectedLineIds;
              periodList = this.trendPeriodList;
              periodType = this.trendPeriodType;
              // viewBy = [this.trendComparisonViewBy];
            } else if (
              this.selectedChartType === CHART_TYPE_DATA.comparison.id
            ) {
              uniquesliidList = this.comparisonSelectedLineIds;
              periodList = this.comparisonPeriodList;
              periodType = this.comparisonPeriodType;
              // viewBy = [this.trendComparisonViewBy];
            } else {
              uniquesliidList = this.trendRevisionSelectedLineIds;
              periodList = this.revisionPeriodList;
              periodType = this.revisionPeriodType;
              // viewBy = [this.revisionViewBy];
            }
            const yearPeriodList = [];
            const otherPeriodList = [];
            for (const item of periodList) {
              if (item === "LTM" || item === "NTM" || item === "STM") {
                otherPeriodList.push(item);
              } else {
                yearPeriodList.push(item);
              }
            }
            const topTenPayload = {
              size: this.topTenTickerSize,
              cid: this.tickers.map(
                (ticker) => ticker.cid || ticker.company_id || ticker.companyid,
              ),
              uniquesliid: uniquesliidList,
              periods_list: yearPeriodList,
              include_top_tickers: true,
              currency: this.currency,
              period_type: periodType,
              other_period: otherPeriodList || [],
              chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
              // view_by: viewBy,
              include_average: this.tickerIncludeAverageSelected,
            };
            this.getTopTenTicker(topTenPayload).subscribe((response) => {
              if (response.status === "success") {
                this.tickerSelectionType = tickerSelectionType;
                this.customTickers = customTickers;
                this.topTenTickers = response.data.top_tickers;
                this.chartOperation = "fetchData";
                this.createChartDataOptions();
                const dataToEmit = {
                  tickers: modalData,
                  customTickers: this.customTickers,
                  topTenTickers: this.topTenTickers,
                  tickerSelectionType: "top_ten",
                };
                // if (pendingDataToEmit) {
                //   dataToEmit = {
                //     ...dataToEmit,
                //     ...pendingDataToEmit,
                //   };
                // }
                this.updateChartState.emit({
                  chartStateToUpdate: ["trend", "comparison", "revision"],
                  data: dataToEmit,
                });
              }
              this.topTenTickersUpdateInProgress = false;
            });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.tickers = modalData;
      this.createCidTickerMapping(modalData);
      // const dataToEmit = {
      //   tickers: modalData,
      //   customTickers: this.customTickers,
      // };
      let periodList = [];
      let uniquesliidList = [];
      let periodType = "absolute";
      // let viewBy = ["values"];
      if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
        uniquesliidList = this.trendRevisionSelectedLineIds;
        periodList = this.trendPeriodList;
        periodType = this.trendPeriodType;
        // viewBy = [this.trendComparisonViewBy];
      } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
        uniquesliidList = this.comparisonSelectedLineIds;
        periodList = this.comparisonPeriodList;
        periodType = this.comparisonPeriodType;
        // viewBy = [this.trendComparisonViewBy];
      } else {
        uniquesliidList = this.trendRevisionSelectedLineIds;
        periodList = this.revisionPeriodList;
        periodType = this.revisionPeriodType;
        // viewBy = [this.revisionViewBy];
      }
      const yearPeriodList = [];
      const otherPeriodList = [];
      for (const item of periodList) {
        if (item === "LTM" || item === "NTM" || item === "STM") {
          otherPeriodList.push(item);
        } else {
          yearPeriodList.push(item);
        }
      }
      const topTenPayload = {
        size: this.topTenTickerSize,
        cid: this.tickers.map(
          (ticker) => ticker.cid || ticker.company_id || ticker.companyid,
        ),
        uniquesliid: uniquesliidList,
        periods_list: yearPeriodList,
        include_top_tickers: true,
        currency: this.currency,
        period_type: periodType,
        other_period: otherPeriodList || [],
        chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
        // view_by: viewBy,
        include_average: this.tickerIncludeAverageSelected,
      };
      this.getTopTenTicker(topTenPayload).subscribe((response) => {
        if (response.status === "success") {
          this.tickerSelectionType = tickerSelectionType;
          this.customTickers = customTickers;
          this.topTenTickers = response.data.top_tickers;
          this.chartOperation = "fetchData";
          this.createChartDataOptions();
          const dataToEmit = {
            tickers: modalData,
            customTickers: this.customTickers,
            topTenTickers: response.data.top_tickers,
            tickerSelectionType: "top_ten",
          };
          // if (pendingDataToEmit) {
          //   dataToEmit = {
          //     ...dataToEmit,
          //     ...pendingDataToEmit,
          //   };
          // }
          this.updateChartState.emit({
            chartStateToUpdate: ["trend", "comparison", "revision"],
            data: dataToEmit,
          });
        }
        this.topTenTickersUpdateInProgress = false;
      });
      const tickerIds = this.tickers.map((item) => {
        return item.ticker;
      });
      this.getPeriodsWithAvailableData(tickerIds);
      this.updateUnsavedDataStatus.emit();
    }
  }

  saveWatchlist(watchistError, modalData, watchlistName) {
    const tickerList = modalData.map((item) => {
      return item.ticker;
    });
    if (
      watchistError === "" &&
      watchlistName &&
      watchlistName.length > 0 &&
      tickerList.length > 0
    ) {
      const jsonData = {
        watchername: watchlistName,
        tickerlist: tickerList,
      };
      // this.isLoadingSaveWatchlist = true;
      let watchlistId = "";
      this.watchlistDataService.saveWatchlist(jsonData).subscribe(
        (response) => {
          if (response.status === "success") {
            watchlistId = response.watchlistid.toString();
            this.addWatchlistStore(watchlistId, watchlistName);
            this.initiateWatchlistFetch.emit();
          }
          this.snackbarInfo.message = `${watchlistName} saved as a new watchlist`;
          this.snackbarInfo.type = "info";
          this.showSnackBarToastMessage(this.snackbarInfo);
        },
        (error) => {
          // this.isLoadingSaveWatchlist = false;
          console.error(error);
        },
      );
    }
  }

  addWatchlistStore(watchlistId, watchlistName) {
    const payload = {
      respData: {
        watchlistId: Number(watchlistId),
        label: watchlistName,
      },
      key: this.storeDataKey,
    };
    this.store.dispatch(new AddWatchlistData(payload));
  }

  createPeriodLabel(periodTypeId, periodList, periodData) {
    const selectedBasisId =
      periodData &&
      periodData.period_basis &&
      periodData.period_basis[periodTypeId]
        ? getSelectedBasisOptionId(
            periodData.period_basis[periodTypeId].from_basis,
          )
        : undefined;

    const isYearlyBasisId = isBasisFullYear(selectedBasisId);

    const periodLabel =
      periodTypeId === "rel"
        ? periodList.map((item) =>
            convertRelativePeriodIdToLabel(item, isYearlyBasisId),
          )
        : periodList;

    return periodLabel;
  }

  /**
   * store meta details to variables
   *  @param {obj} meta: meta details
   */
  updateStateWithMeta(meta) {
    //common
    const tickersData = meta.tickers;
    this.tickers = tickersData.ticker_info;
    this.customTickers = tickersData.custom || [];
    this.topTenTickers = tickersData.top_ten;
    this.headerTitle = meta.comps_name;
    this.isIndexToHundreadSelected = meta.index_to_100;
    this.currency = meta.currency;
    this.tickerSelectionType = meta.ticker_selected_type;
    this.tickerIncludeAverageSelected = meta.include_average;
    this.suggestedLineItems = meta.suggested_line_info
      ? meta.suggested_line_info.map((item) => {
          return {
            ...item,
            label: item.name,
            sli_id_count: item.sli_id_count || item.count,
            id: item.uniquesliid,
            sli_id: item.uniquesliid,
            disabled: false,
            isLeaf: true,
            level: 2,
            header: false,
            isCollapsed: true,
          };
        })
      : [];
    this.createCidTickerMapping(this.tickers);

    //specific
    if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
      this.trendRevisionSelectedLineItems = meta.selected_lines;
      this.trendRevisionSelectedLineIds = meta.selected_lines.map(
        (item) => item.uniquesliid,
      );
      this.trendComparisonViewBy = meta.data_view
        ? meta.data_view.view_by[0]
        : undefined;
      this.trendPeriodData = meta.period_selector;
      this.trendPeriodUserSetting = convertPeriodMetaToUserSettings(
        meta.period_selector,
      );
      this.trendPeriodList = getSelectedPeriods(
        meta.period_selector,
        false,
        false,
        false,
      );
      const periodType = getPeriodTypeDataId(meta.period_selector);
      this.trendPeriodType = periodType;
      this.trendPeriodLabel = this.createPeriodLabel(
        this.trendPeriodUserSetting.type,
        this.trendPeriodList,
        this.trendPeriodData,
      );

      // emitting the data that we need to save the unsaved chart
      this.updateChartState.emit({
        chartStateToUpdate: ["trend"],
        data: {
          tickers: this.tickers,
          customTickers: this.customTickers,
          topTenTickers: this.topTenTickers,
          tickerSelectionType: this.tickerSelectionType,
          tickerIncludeAverageSelected: this.tickerIncludeAverageSelected,
          isIndexToHundreadSelected: this.isIndexToHundreadSelected,
          currency: this.currency,
          lineItem: this.trendRevisionSelectedLineItems,
          selectedLineItemId: this.trendRevisionSelectedLineIds,
          periodUserSetting: this.trendPeriodUserSetting,
          periodType: periodType,
          periodData: this.trendPeriodData,
          periodList: this.trendPeriodList,
          periodLabel: this.trendPeriodLabel,
          viewBy: [this.trendComparisonViewBy],
          headerTitle: this.headerTitle,
        },
      });
    } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
      this.comparisonSelectedLineItems = meta.selected_lines;
      this.comparisonSelectedLineIds = meta.selected_lines.map(
        (item) => item.uniquesliid,
      );
      this.trendComparisonViewBy = meta.data_view
        ? meta.data_view.view_by[0]
        : undefined;
      this.comparisonPeriodData = meta.period_selector;
      this.comparisonPeriodUserSetting = convertPeriodMetaToUserSettings(
        meta.period_selector,
      );
      this.comparisonPeriodList = getSelectedPeriods(
        meta.period_selector,
        false,
        false,
        true,
      );
      this.comparisonOtherPeriodList = getOtherPeriods(meta.period_selector);
      const periodType = getPeriodTypeDataId(meta.period_selector);
      this.comparisonPeriodType = periodType;
      this.comparisonPeriodLabel = this.createPeriodLabel(
        this.comparisonPeriodUserSetting.type,
        this.comparisonPeriodList,
        this.comparisonPeriodData,
      );

      // emitting the data that we need to save the unsaved chart
      this.updateChartState.emit({
        chartStateToUpdate: ["comparison"],
        data: {
          tickers: this.tickers,
          customTickers: this.customTickers,
          topTenTickers: this.topTenTickers,
          tickerSelectionType: this.tickerSelectionType,
          tickerIncludeAverageSelected: this.tickerIncludeAverageSelected,
          isIndexToHundreadSelected: this.isIndexToHundreadSelected,
          currency: this.currency,
          lineItem: this.comparisonSelectedLineItems,
          selectedLineItemId: this.comparisonSelectedLineIds,
          periodUserSetting: this.comparisonPeriodUserSetting,
          periodType: periodType,
          periodList: this.comparisonPeriodList,
          periodData: this.comparisonPeriodData,
          periodLabel: this.comparisonPeriodLabel,
          viewBy: [this.trendComparisonViewBy],
        },
      });
    } else {
      this.trendRevisionSelectedLineItems = meta.selected_lines;
      this.trendRevisionSelectedLineIds = meta.selected_lines.map(
        (item) => item.uniquesliid,
      );
      this.revisionValueOfRevisionChart = meta.data_view
        ? meta.data_view.revision
        : undefined;
      this.revisionViewBy = "revision";
      this.revisionChartPeriodData = meta.period_selector;
      this.revisionChartPeriodUserSetting = convertPeriodMetaToUserSettings(
        meta.period_selector,
      );
      this.revisionPeriodList = getSelectedPeriods(
        meta.period_selector,
        false,
        false,
        true,
      );
      this.revisionOtherPeriodList = getOtherPeriods(meta.period_selector);
      const periodType = getPeriodTypeDataId(meta.period_selector);
      this.revisionPeriodType = periodType;
      this.revisionPeriodLabel = this.createPeriodLabel(
        this.revisionChartPeriodUserSetting.type,
        this.revisionPeriodList,
        this.revisionChartPeriodData,
      );

      // emitting the data that we need to save the unsaved chart
      this.updateChartState.emit({
        chartStateToUpdate: ["revision"],
        data: {
          tickers: this.tickers,
          customTickers: this.customTickers,
          topTenTickers: this.topTenTickers,
          tickerSelectionType: this.tickerSelectionType,
          tickerIncludeAverageSelected: this.tickerIncludeAverageSelected,
          isIndexToHundreadSelected: this.isIndexToHundreadSelected,
          currency: this.currency,
          lineItem: this.trendRevisionSelectedLineItems,
          selectedLineItemId: this.trendRevisionSelectedLineIds,
          periodUserSetting: this.revisionChartPeriodUserSetting,
          periodType: periodType,
          periodData: this.revisionChartPeriodData,
          periodList: this.revisionPeriodList,
          periodLabel: this.revisionPeriodLabel,
          viewBy: [this.revisionViewBy],
          revision: this.revisionValueOfRevisionChart,
        },
      });
    }
    const tickerIds = this.tickers.map((item) => {
      return item.ticker;
    });
    this.getPeriodsWithAvailableData(tickerIds);
  }

  onChartTypeChange(item) {
    const previousSelectedChartType = this.selectedChartType;
    this.selectedChartType = item;
    const isTrendChartType = item === CHART_TYPE_DATA.trend.id;
    const isComparisonChartType = item === CHART_TYPE_DATA.comparison.id;
    const isRevisionChartType = item === CHART_TYPE_DATA.revision.id;
    this.chartOperation = "fetchData";
    if (
      (!this.isRevisionMetaFetchedOnce && isRevisionChartType) ||
      (!this.isComparisonMetaFetchedOnce && isComparisonChartType) ||
      (!this.isTrendMetaFetchedOnce && isTrendChartType)
    ) {
      const isUserPageType = this.checkIfUserPageType();
      const chartMetaId = CHART_TYPE_DATA[this.selectedChartType]
        ? CHART_TYPE_DATA[this.selectedChartType].meta_id
        : undefined;
      const state = isRevisionChartType
        ? this.revisionState
        : isComparisonChartType
          ? this.comparisonState
          : this.trendState;
      const metaPayload = isUserPageType
        ? getMetaPayloadFromUrls(
            this.routeParams,
            this.routeQueryParams,
            this.tabType,
            this.compType,
            undefined,
            chartMetaId,
          )
        : getMetaPayloadFromUrls(
            this.routeParams,
            this.routeQueryParams,
            this.tabType,
            this.compType,
            state,
            chartMetaId,
          );
      this.fetchAndUpdateComparativeMeta(metaPayload);
    } else {
      if (
        this.tickerSelectionType === "top_ten" &&
        (this.selectedChartType === CHART_TYPE_DATA.comparison.id ||
          previousSelectedChartType === CHART_TYPE_DATA.comparison.id)
      ) {
        if (this.tickerSelectionType === "top_ten") {
          let periodList = [];
          let uniquesliidList = [];
          let periodType = "absolute";
          if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
            uniquesliidList = this.trendRevisionSelectedLineIds;
            periodList = this.trendPeriodList;
            periodType = this.trendPeriodType;
          } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
            uniquesliidList = this.comparisonSelectedLineIds;
            periodList = this.comparisonPeriodList;
            periodType = this.comparisonPeriodType;
          } else {
            uniquesliidList = this.trendRevisionSelectedLineIds;
            periodType = this.revisionPeriodType;
          }
          const yearPeriodList = [];
          const otherPeriodList = [];
          for (const item of periodList) {
            if (item === "LTM" || item === "NTM" || item === "STM") {
              otherPeriodList.push(item);
            } else {
              yearPeriodList.push(item);
            }
          }
          const topTenPayload = {
            size: this.topTenTickerSize,
            cid: this.tickers.map(
              (ticker) => ticker.cid || ticker.company_id || ticker.companyid,
            ),
            uniquesliid: uniquesliidList,
            periods_list: yearPeriodList,
            include_top_tickers: true,
            currency: this.currency,
            period_type: periodType,
            other_period: otherPeriodList || [],
            chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
            include_average: this.tickerIncludeAverageSelected,
          };

          this.getTopTenTicker(topTenPayload).subscribe((response) => {
            if (response.status === "success") {
              this.topTenTickers = response.data.top_tickers;
              this.chartOperation = "fetchData";
              this.createChartDataOptions();
              const dataToEmit = {
                tickerSelectionType: this.tickerSelectionType,
                tickerIncludeAverageSelected: this.tickerIncludeAverageSelected,
                topTenTickers: response.data.top_tickers,
              };
              this.updateChartState.emit({
                chartStateToUpdate: ["trend", "comparison", "revision"],
                data: dataToEmit,
              });
            }
            this.topTenTickersUpdateInProgress = false;
          });
        }
      } else {
        this.createChartDataOptions();
      }
    }
  }

  getPeriodDataForBinding() {
    return this.selectedChartType === CHART_TYPE_DATA.revision.id
      ? this.revisionChartPeriodData
      : this.selectedChartType === CHART_TYPE_DATA.comparison.id
        ? this.comparisonPeriodData
        : this.trendPeriodData;
  }

  getSelectedLineIdsFoBinding() {
    return this.selectedChartType === CHART_TYPE_DATA.comparison.id
      ? this.comparisonSelectedLineIds
      : this.trendRevisionSelectedLineIds;
  }

  getSelectedLineItems() {
    return this.selectedChartType === CHART_TYPE_DATA.comparison.id
      ? this.comparisonSelectedLineItems
      : this.trendRevisionSelectedLineItems;
  }

  getDisplayList() {
    return this.selectedChartType === CHART_TYPE_DATA.comparison.id
      ? this.comparisonPeriodList
      : this.trendRevisionSelectedLineIds;
  }

  getPeriodLabel() {
    return this.selectedChartType === CHART_TYPE_DATA.comparison.id
      ? this.comparisonPeriodLabel
      : this.selectedChartType === CHART_TYPE_DATA.revision.id
        ? this.revisionPeriodLabel
        : this.trendPeriodLabel;
  }

  getChartOptionsForBinding() {
    return this.selectedChartType === CHART_TYPE_DATA.revision.id
      ? this.revisionChartOptions
      : this.selectedChartType === CHART_TYPE_DATA.comparison.id
        ? this.comparisonChartOptions
        : this.trendChartOptions;
  }

  createChartDataOptions() {
    const topTenObj = {};
    if (this.topTenTickers) {
      Object.keys(this.topTenTickers).forEach((uniquesliId) => {
        topTenObj[uniquesliId] = this.topTenTickers[uniquesliId]
          ? this.topTenTickers[uniquesliId].map((cid) => {
              return this.cidMapper[cid];
            })
          : [];
      });
    }

    const tickerData = {
      allTickers: this.tickers,
      custom: this.customTickers.map((cid) => {
        return this.cidMapper[cid];
      }),
      ...topTenObj,
    };
    if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
      const lineInfo = {};
      for (const item of this.trendRevisionSelectedLineItems) {
        lineInfo[item.uniquesliid] = item;
      }
      const options = {
        periods: this.trendPeriodList,
        otherPeriods: undefined,
        periodType: this.trendPeriodType,
        linesData: this.trendRevisionSelectedLineIds,
        dataView:
          this.trendComparisonViewBy === "values"
            ? "value"
            : this.trendComparisonViewBy,
        lineInfoData: lineInfo,
        scaleType: this.isIndexToHundreadSelected ? 2 : 1,
        operation: this.chartOperation,
        seriesInfo: {},
        hoveredTicker: "",
        currency: this.currency,
        revision: undefined,
        chartTypeId: "2",
        legendColors: TREND_REVISION_CHART_LEGEND_COLORS,
        legendShapes: [],
        isSecondaryAxis: false,
        chartName: this.headerTitle,
        tickerData,
        tickerType: this.tickerSelectionType,
        isComparativePageChart: true,
        shouldShowAverage: this.tickerIncludeAverageSelected,
      };
      this.trendChartOptions = options;
    } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
      const lineInfo = {};
      for (const item of this.comparisonSelectedLineItems) {
        lineInfo[item.uniquesliid] = item;
      }
      const options = {
        periods: this.comparisonPeriodList,
        otherPeriods: this.comparisonOtherPeriodList,
        periodType: this.comparisonPeriodType,
        linesData: this.comparisonSelectedLineIds,
        dataView:
          this.trendComparisonViewBy === "values"
            ? "value"
            : this.trendComparisonViewBy,
        lineInfoData: lineInfo,
        scaleType: this.isIndexToHundreadSelected ? 2 : 1,
        operation: this.chartOperation,
        seriesInfo: {},
        hoveredTicker: "",
        currency: this.currency,
        revision: undefined,
        chartTypeId: "1",
        legendColors: COMPARISON_CHART_LEGEND_COLORS,
        legendShapes: [],
        isSecondaryAxis: false,
        chartName: this.headerTitle,
        tickerData,
        tickerType: this.tickerSelectionType,
        isComparativePageChart: true,
      };
      this.comparisonChartOptions = options;
    } else {
      const lineInfo = {};
      for (const item of this.trendRevisionSelectedLineItems) {
        lineInfo[item.uniquesliid] = item;
      }
      const options = {
        periods:
          this.revisionOtherPeriodList && this.revisionOtherPeriodList.length
            ? []
            : this.revisionPeriodList,
        industryId: this.industryId,
        otherPeriods: this.revisionOtherPeriodList,
        periodType: this.revisionPeriodType,
        linesData: this.trendRevisionSelectedLineIds,
        // dataView: this.revisionViewBy,
        lineInfoData: lineInfo,
        scaleType: this.isIndexToHundreadSelected ? 2 : 1,
        operation: this.chartOperation,
        seriesInfo: {},
        hoveredTicker: "",
        currency: this.currency,
        revision: this.revisionValueOfRevisionChart,
        chartTypeId: "3",
        legendColors: TREND_REVISION_CHART_LEGEND_COLORS,
        legendShapes: [],
        isSecondaryAxis: false,
        chartName: this.headerTitle,
        tickerData,
        tickerType: this.tickerSelectionType,
        isComparativePageChart: true,
        shouldShowAverage: this.tickerIncludeAverageSelected,
      };
      this.revisionChartOptions = options;
    }
    this.onDataFetchInitiate.emit();
  }

  onDataViewChange(newDataView) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const dataViewUpdate = {
        DataView: {
          view_by: [newDataView],
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        CHART_TYPE_DATA[this.selectedChartType].meta_id,
        dataViewUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.trendComparisonViewBy = newDataView;
            this.chartOperation = "fetchData";
            this.createChartDataOptions();
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.trendComparisonViewBy = newDataView;
      this.chartOperation = "fetchData";
      this.createChartDataOptions();
      this.updateChartState.emit({
        chartStateToUpdate: [this.selectedChartType],
        data: { view_by: [newDataView] },
      });
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * Accepts 3 boolean parameters which states whether that filter
   * needs to be shown or not
   * The order of params is: Trend, Comparison and Revision
   */
  showFilter(
    showOnTrend: boolean,
    showOnComparison: boolean,
    showOnRevision: boolean,
  ) {
    if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
      return showOnTrend;
    }
    if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
      return showOnComparison;
    }

    return showOnRevision;
  }

  handleIndexCheckboxChange(item) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const indexToHundreddToUpdate = {
        IndexTo100: {
          index_to_100: item,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        CHART_TYPE_DATA[this.selectedChartType].meta_id,
        indexToHundreddToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.isIndexToHundreadSelected = item;
            this.chartOperation = "fetchData";
            this.createChartDataOptions();
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.isIndexToHundreadSelected = item;
      this.chartOperation = "fetchData";
      this.createChartDataOptions();
      this.updateChartState.emit({
        chartStateToUpdate: ["trend", "comparison", "revision"],
        data: { isIndexToHundreadSelected: item },
      });
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * This function is fired when the save Revision event is fired from the revision history filter component.
   * It updates the revision in the state and calls the saveusersettings api to save it.
   * @param item selected revision value
   */
  onRevisionChange(item: string) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;

      const revisionHistoryToUpdate = {
        DataView: {
          revision: item,
          view_by: ["revision"],
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        CHART_TYPE_DATA[this.selectedChartType].meta_id,
        revisionHistoryToUpdate,
      );

      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.revisionViewBy = "revision";
            this.revisionValueOfRevisionChart = item;
            this.updateChartState.emit({
              chartStateToUpdate: ["revision"],
              data: {
                viewBy: ["revision"],
                revision: item,
              },
            });
            this.chartOperation = "fetchData";
            this.createChartDataOptions();
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.revisionViewBy = "revision";
      this.revisionValueOfRevisionChart = item;
      this.updateChartState.emit({
        chartStateToUpdate: ["revision"],
        data: {
          viewBy: ["revision"],
          revision: item,
        },
      });
      this.updateUnsavedDataStatus.emit();
      this.chartOperation = "fetchData";
      this.createChartDataOptions();
    }
  }

  createCidTickerMapping(tickerObj) {
    this.cidMapper = {};
    tickerObj.forEach((obj) => {
      this.cidMapper[obj.companyid || obj.cid] = {
        companyid: obj.companyid || obj.cid,
        full_name: obj.full_name || obj.name,
        ticker: obj.ticker,
      };
    });
  }

  handleTickerSelectionTypeChange(updatedObj) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;

      const tickerSelectionTypeToUpdate = {
        Ticker: {
          cids: this.tickers.map(
            (ticker) => ticker.company_id || ticker.cid || ticker.companyid,
          ),
          chart_ticker_selected_type: updatedObj.tickerSelectionType,
          chart_custom_cid: updatedObj.customTickers,
          chart_include_average: updatedObj.includeAverage || false,
        },
      };

      const settingsPayload = updateCustomTableSettings(
        this.compId,
        CHART_TYPE_DATA[this.selectedChartType].meta_id,
        tickerSelectionTypeToUpdate,
      );

      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            if (this.tickerSelectionType === "top_ten") {
              // const dataToEmit = {
              //   tickerSelectionType: updatedObj.tickerSelectionType,
              //   tickerIncludeAverageSelected: updatedObj.includeAverage,
              // };
              let periodList = [];
              let uniquesliidList = [];
              let periodType = "absolute";
              // let viewBy = ["values"];
              if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
                uniquesliidList = this.trendRevisionSelectedLineIds;
                periodList = this.trendPeriodList;
                periodType = this.trendPeriodType;
                // viewBy = [this.trendComparisonViewBy];
              } else if (
                this.selectedChartType === CHART_TYPE_DATA.comparison.id
              ) {
                uniquesliidList = this.comparisonSelectedLineIds;
                periodList = this.comparisonPeriodList;
                periodType = this.comparisonPeriodType;
                // viewBy = [this.trendComparisonViewBy];
              } else {
                uniquesliidList = this.trendRevisionSelectedLineIds;
                periodList = this.revisionPeriodList;
                periodType = this.revisionPeriodType;
                // viewBy = [this.revisionViewBy];
              }
              const yearPeriodList = [];
              const otherPeriodList = [];
              for (const item of periodList) {
                if (item === "LTM" || item === "NTM" || item === "STM") {
                  otherPeriodList.push(item);
                } else {
                  yearPeriodList.push(item);
                }
              }
              const topTenPayload = {
                size: this.topTenTickerSize,
                cid: this.tickers.map(
                  (ticker) =>
                    ticker.cid || ticker.company_id || ticker.companyid,
                ),
                uniquesliid: uniquesliidList,
                periods_list: yearPeriodList,
                include_top_tickers: true,
                currency: this.currency,
                period_type: periodType,
                other_period: otherPeriodList || [],
                chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
                // view_by: viewBy,
                include_average: this.tickerIncludeAverageSelected,
              };

              this.getTopTenTicker(topTenPayload).subscribe((response) => {
                if (response.status === "success") {
                  this.tickerSelectionType = updatedObj.tickerSelectionType;
                  this.customTickers = updatedObj.customTickers;
                  this.tickerIncludeAverageSelected = updatedObj.includeAverage;
                  this.topTenTickers = response.data.top_tickers;
                  this.chartOperation = "fetchData";
                  this.createChartDataOptions();
                  const dataToEmit = {
                    tickerSelectionType: updatedObj.tickerSelectionType,
                    tickerIncludeAverageSelected: updatedObj.includeAverage,
                    topTenTickers: response.data.top_tickers,
                    // tickerSelectionType: "top_ten",
                  };
                  // if (pendingDataToEmit) {
                  //   dataToEmit = {
                  //     ...dataToEmit,
                  //     ...pendingDataToEmit,
                  //   };
                  // }
                  this.updateChartState.emit({
                    chartStateToUpdate: ["trend", "comparison", "revision"],
                    data: dataToEmit,
                  });
                }
                this.topTenTickersUpdateInProgress = false;
              });
            } else {
              this.tickerSelectionType = updatedObj.tickerSelectionType;
              this.customTickers = updatedObj.customTickers;
              this.tickerIncludeAverageSelected = updatedObj.includeAverage;
              this.chartOperation = "fetchData";
              this.createChartDataOptions();
              this.updateChartState.emit({
                chartStateToUpdate: ["trend", "comparison", "revision"],
                data: {
                  tickerSelectionType: updatedObj.tickerSelectionType,
                  customTickers: updatedObj.customTickers,
                  tickerIncludeAverageSelected: updatedObj.includeAverage,
                },
              });
            }
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      if (updatedObj.tickerSelectionType === "top_ten") {
        let periodList = [];
        let uniquesliidList = [];
        let periodType = "absolute";
        // let viewBy = ["values"];
        if (this.selectedChartType === CHART_TYPE_DATA.trend.id) {
          uniquesliidList = this.trendRevisionSelectedLineIds;
          periodList = this.trendPeriodList;
          periodType = this.trendPeriodType;
          // viewBy = [this.trendComparisonViewBy];
        } else if (this.selectedChartType === CHART_TYPE_DATA.comparison.id) {
          uniquesliidList = this.comparisonSelectedLineIds;
          periodList = this.comparisonPeriodList;
          periodType = this.comparisonPeriodType;
          // viewBy = [this.trendComparisonViewBy];
        } else {
          uniquesliidList = this.trendRevisionSelectedLineIds;
          periodList = this.revisionPeriodList;
          periodType = this.revisionPeriodType;
          // viewBy = [this.revisionViewBy];
        }
        const yearPeriodList = [];
        const otherPeriodList = [];
        for (const item of periodList) {
          if (item === "LTM" || item === "NTM" || item === "STM") {
            otherPeriodList.push(item);
          } else {
            yearPeriodList.push(item);
          }
        }
        const topTenPayload = {
          size: this.topTenTickerSize,
          cid: this.tickers.map(
            (ticker) => ticker.cid || ticker.company_id || ticker.companyid,
          ),
          uniquesliid: uniquesliidList,
          periods_list: yearPeriodList,
          include_top_tickers: true,
          currency: this.currency,
          period_type: periodType,
          other_period: otherPeriodList || [],
          chart_type: CHART_TYPE_DATA[this.selectedChartType].meta_id,
          // view_by: viewBy,
          include_average: this.tickerIncludeAverageSelected,
        };
        this.getTopTenTicker(topTenPayload).subscribe((response) => {
          if (response.status === "success") {
            this.tickerSelectionType = updatedObj.tickerSelectionType;
            this.customTickers = updatedObj.customTickers;
            this.tickerIncludeAverageSelected = updatedObj.includeAverage;
            this.topTenTickers = response.data.top_tickers;
            this.chartOperation = "fetchData";
            this.createChartDataOptions();
            const dataToEmit = {
              tickerSelectionType: updatedObj.tickerSelectionType,
              tickerIncludeAverageSelected: updatedObj.includeAverage,
              topTenTickers: response.data.top_tickers,
              // tickerSelectionType: "top_ten",
            };
            // if (pendingDataToEmit) {
            //   dataToEmit = {
            //     ...dataToEmit,
            //     ...pendingDataToEmit,
            //   };
            // }
            this.updateChartState.emit({
              chartStateToUpdate: ["trend", "comparison", "revision"],
              data: dataToEmit,
            });
          }
          this.topTenTickersUpdateInProgress = false;
        });
      } else {
        this.tickerSelectionType = updatedObj.tickerSelectionType;
        this.customTickers = updatedObj.customTickers;
        this.tickerIncludeAverageSelected = updatedObj.includeAverage;
        this.chartOperation = "fetchData";
        this.createChartDataOptions();
        this.updateChartState.emit({
          chartStateToUpdate: ["trend", "comparison", "revision"],
          data: {
            tickerSelectionType: updatedObj.tickerSelectionType,
            customTickers: updatedObj.customTickers,
            tickerIncludeAverageSelected: updatedObj.includeAverage,
          },
        });
      }
      this.updateUnsavedDataStatus.emit();
    }
  }

  updateFormattedLineItem(dataToEmit, chartStateToUpdate) {
    this.dataService
      .getLineItemDetails(
        dataToEmit.selectedLineItemId,
        this.industryId,
        this.currency,
        this.tickers[0].ticker,
        this.isChartPage,
      )
      .subscribe((response) => {
        if (response.status === "success" && response.data) {
          dataToEmit.lineItem.forEach((item) => {
            item["formatted_name"] = response.data[item.uniquesliid]
              ? response.data[item.uniquesliid]["formatted_name"]
              : item.name;
            item["totaled"] = response.data[item.uniquesliid]
              ? response.data[item.uniquesliid]["totaled"]
              : false;
            item["curr_symbol"] = response.data[item.uniquesliid]
              ? response.data[item.uniquesliid]["curr_symbol"]
              : "";
            item["unit"] = response.data[item.uniquesliid]
              ? response.data[item.uniquesliid]["unit"]
              : "";
            item["magnitude"] = response.data[item.uniquesliid]
              ? response.data[item.uniquesliid]["magnitude"]
              : "";
          });
        }
        this.updateChartState.emit({
          chartStateToUpdate: chartStateToUpdate || [
            "trend",
            "comparison",
            "revision",
          ],
          data: dataToEmit,
        });
      });
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }

  getTopTenTicker(topTenPayload) {
    this.topTenTickersUpdateInProgress = true;
    return this.dataService.getTopTenTickers(topTenPayload);
  }

  updateDownloadStatus(event) {
    this.isDownloadingInProgress.emit(event);
  }

  getPeriodFilterWidth() {
    return this.selectedChartType === CHART_TYPE_DATA.revision.id ? 1 : 2;
  }
}
